var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerified2 = function SvgVerified2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "verified-2_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FB3C6C",
    mask: "url(#verified-2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.073 18.159c1.198 1.018 2.175 1.849 4.083 2.612 3.282 1.312 8.514-3.34 10.027-5.628 1.582-2.39 2.473-5.658 1.236-7.628-.05-.08-.1-.157-.152-.232L12.25 16.3c-.1.1-.208.17-.325.212a1.098 1.098 0 0 1-.375.063 1.1 1.1 0 0 1-.375-.063.872.872 0 0 1-.325-.212L6.55 12c-.183-.183-.27-.421-.263-.713.009-.291.105-.529.288-.712a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275l3.575 3.575 8.297-8.297c-1.134-.764-2.565-1.033-4.254-.733-1.714.304-2.657.991-3.365 1.508-.367.268-.67.49-.987.59-.322.1-.65-.114-1.085-.4-.816-.536-2.01-1.32-4.256-.725-3.444.912-4.059 4.535-3.87 6.126.19 1.591 1.198 3.562 3.452 5.44.206.172.401.338.591.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.302 4.006c-.428.813-2.09 1.779-2.228 1.779-.137 0-1.509-1.01-1.98-1.886-.47-.877.136-1.586.73-1.693.34-.06.597.148.813.323.163.133.303.246.437.208.096-.028.213-.13.35-.25.304-.267.707-.62 1.202-.435.716.268 1.103 1.14.676 1.954Z"
  }))));
};
export default SvgVerified2;